import axios from 'axios';
import Config from '../../cankado-config';
import events from '../event-names';
import { apiHeaders } from '../../kado/utils/';

export default (patient) => ({
    type: events.FETCH_ASS_KEY_LIST,
    payload: axios.get(`${Config.apiRoot}/patient/${patient}/accesskey/assessment/`, { ...apiHeaders() }),
});